import { jsx as _jsx } from "react/jsx-runtime";
import { ResourceModalForm } from '../EntityModalForms/ResourceModalForm';
import './CreateResourceModal.scss';
function CreateResourceModal({ isOpen, onClose, onCreate, isLoading }) {
    return (_jsx(ResourceModalForm, { isOpen: isOpen, onClose: onClose, onSubmit: onCreate, isLoading: isLoading, mode: "create", resource: null, title: "Create New Resource", submitIdleLabel: "Create Resource", submitBusyLabel: "Creating..." }));
}
export default CreateResourceModal;
